import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../coreFIles/config";

export default function AuthWrapper({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Function to get cookie by name
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const authCookie = getCookie('OnchainMatrix');
    const publicPaths = [
      `${config.baseUrl}`,
      `${config.baseUrl}forget-password`,
    ];
    const isPublic = publicPaths.includes(location.pathname);

    if (!authCookie && !isPublic) {
      navigate(`${config.baseUrl}`);
    }

    if (authCookie && location.pathname === `${config.baseUrl}`) {
      navigate(`${config.baseUrl}seed-round`);
    }
  }, [navigate, location]);

  return children;
}